module.exports = __webpack_public_path__ + "/img/Oscillator-LBend-7UXmkf.svg";